import { env } from './env';

const ENVIRONMENT = env.REACT_APP_ENVIRONMENT;
const APP_VERSION = env.REACT_APP_VERSION;
const APP_BFF_API = env.REACT_APP_BFF_API;
const APP_BFF_API_DOCS = env.REACT_APP_BFF_API_DOCS;

const APP_AAD_AUTHORITY = env.REACT_APP_AAD_AUTHORITY;
const APP_AAD_CLIENT_ID = env.REACT_APP_AAD_CLIENT_ID;
const AAD_LOGIN_REDIRECT_URI = env.REACT_APP_AAD_LOGIN_REDIRECT_URI;
const APP_AAD_LOGOUT_REDIRECT_URI = env.REACT_APP_AAD_LOGOUT_REDIRECT_URI;
const APP_AAD_SCOPES = env.REACT_APP_AAD_SCOPES;
const APP_MAX_FILESIZE = env.REACT_APP_BFF_MAX_FILESIZE_MB;
const SUPPORT_EMAIL = env.REACT_APP_SUPPORT_EMAIL;
const APP_BFF_PATH_LOGIN = env.REACT_APP_BFF_PATH_LOGIN;
const APP_BFF_PATH_LANDING = env.REACT_APP_BFF_PATH_LANDING;
const APP_BFF_PATH_SUMMARY = env.REACT_APP_BFF_PATH_SUMMARY;
const APP_BFF_PATH_API = env.REACT_APP_BFF_PATH_API;
const APP_BFF_PATH_SUPPORT = env.REACT_APP_BFF_PATH_SUPPORT;
const APP_BFF_PATH_FEEDBACK = env.REACT_APP_BFF_PATH_FEEDBACK;
const APP_BFF_PATH_SOMETHING_MISSING = env.REACT_APP_BFF_PATH_SOMETHING_MISSING;
const APP_BFF_PATH_SORRY = env.REACT_APP_BFF_PATH_SORRY;
const APP_BFF_PATH_FORBBIDEN = env.REACT_APP_BFF_PATH_FORBBIDEN;
const APP_BFF_PATH_COSTS = env.REACT_APP_BFF_PATH_COSTS;
const APP_BFF_PATH_COST_METERING = env.REACT_APP_BFF_PATH_COST_METERING;
const APP_BFF_PATH_COST_ESTIMATOR = env.REACT_APP_BFF_PATH_COST_ESTIMATOR;
const REACT_APP_AAD_ENABLED = env.REACT_APP_AAD_ENABLED;
const APP_BFF_PATH_COVERAGE_CHECK_2 = env.REACT_APP_BFF_PATH_COVERAGE_CHECK_2;

const APP_SHOW_BETA_MODAL = env.REACT_APP_SHOW_BETA_MODAL;
const APP_DOC_GENERATOR_URL = env.REACT_APP_DOC_GENERATOR_URL;

export default {
  APP: {
    ENVIRONMENT,
    VERSION: APP_VERSION,
    API: APP_BFF_API,
    API_DOCS: APP_BFF_API_DOCS,
    MAX_FILESIZE: APP_MAX_FILESIZE,
    SUPPORT_EMAIL,
    PATH: {
      LOGIN: APP_BFF_PATH_LOGIN,
      LANDING: APP_BFF_PATH_LANDING,
      SUMMARY: APP_BFF_PATH_SUMMARY,
      API: APP_BFF_PATH_API,
      SUPPORT: APP_BFF_PATH_SUPPORT,
      FEEDBACK: APP_BFF_PATH_FEEDBACK,
      SOMETHING_MISSING: APP_BFF_PATH_SOMETHING_MISSING,
      SORRY: APP_BFF_PATH_SORRY,
      FORBIDDEN: APP_BFF_PATH_FORBBIDEN,
      COSTS: APP_BFF_PATH_COSTS,
      COST_METERING: APP_BFF_PATH_COST_METERING,
      COST_ESTIMATOR: APP_BFF_PATH_COST_ESTIMATOR,
      COVERAGE_CHECK_V2: APP_BFF_PATH_COVERAGE_CHECK_2
    },
    DOC_GENERATOR_URL: APP_DOC_GENERATOR_URL,
    FUNCTIONALITIES: {
      SHOW_BETA_MODAL: APP_SHOW_BETA_MODAL
    }
  },
  INTEGRATION: {
    bootstrap: '/portal/bootstrap'
  },
  AUTH: {
    AUTHORITY: APP_AAD_AUTHORITY,
    CLIENT_ID: APP_AAD_CLIENT_ID,
    LOGIN_REDIRECT_URI: AAD_LOGIN_REDIRECT_URI,
    LOGOUT_REDIRECT_URI: APP_AAD_LOGOUT_REDIRECT_URI,
    SCOPES: APP_AAD_SCOPES,
    ENABLED: REACT_APP_AAD_ENABLED
  }
};
